var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextAttach = function SvgTextAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.796 1.396 5.018 4.173c-.22.22-.123.671.218 1.012L9.541 9.49c.163.164.362.278.551.32.19.04.356.004.461-.101l2.778-2.778c.105-.105.141-.271.1-.46a1.154 1.154 0 0 0-.318-.552L8.806 1.614a1.154 1.154 0 0 0-.55-.319c-.19-.04-.356-.004-.461.1Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 7H2.333C1.593 7 1 7.494 1 8.111v7.778c0 .295.14.577.39.786.25.208.59.325.943.325h9.334c.353 0 .692-.117.943-.325.25-.209.39-.491.39-.786V8.11c0-.295-.14-.577-.39-.786A1.48 1.48 0 0 0 11.667 7Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.832 6.5h4.583L7.832 1.917V6.5ZM1.999.667h6.666l5 5v10A1.667 1.667 0 0 1 12 17.334h-10a1.667 1.667 0 0 1-1.667-1.667V2.334A1.66 1.66 0 0 1 1.999.667ZM9.499 14v-1.666h-7.5V14h7.5Zm2.5-3.333V9h-10v1.667h10Z",
    fill: "#02006D"
  })));
};
export default SvgTextAttach;